import { FilterUserEnum, StatusFinishedEnum } from '@helpers/enums';
import { IFilterGroupsCategories } from './iFilterGroupsCategories';
import { IRangeDate } from './iRangeDate';

export interface IReportFilters {
  users_id: (number | null)[];
  groups_categories_id: IFilterGroupsCategories[];
  range_date: IRangeDate | null;
  filterUserEnum: FilterUserEnum;
  filterStatusFinishedEnum?: StatusFinishedEnum[];
}

class ReportFiltersClass implements IReportFilters {
  users_id: (number | null)[];
  groups_categories_id: IFilterGroupsCategories[];
  range_date: IRangeDate | null;
  filterUserEnum: FilterUserEnum;
  filterStatusFinishedEnum?: StatusFinishedEnum[] = [];

  constructor(
    users_id: (number | null)[],
    groups_categories_id: IFilterGroupsCategories[],
    range_date: IRangeDate | null,
    filterUserEnum: FilterUserEnum,
    filterStatusFinishedEnum?: StatusFinishedEnum[],
  ) {
    this.users_id = users_id ?? [];
    this.groups_categories_id = groups_categories_id ?? [];
    this.range_date = range_date;
    this.filterUserEnum = filterUserEnum;
    this.filterStatusFinishedEnum = filterStatusFinishedEnum;
  }
}

export default ReportFiltersClass;
